require('./dashboard.style.scss');
const angularModule = angular.module('com.comtrade.azureCloud.backup');
angularModule.service('dashboardService', require('./dashboard.service'));

class DashboardController {
    constructor($scope, $element, $timeout, dashboardService, utilsService, gridsterPositions, $stateParams) {
        this.$scope = $scope;
        this.$element = $element;
        this.$timeout = $timeout;
        this.dashboardService = dashboardService;
        this.utilsService = utilsService;
        this.gridsterPositions = gridsterPositions;
        this.$stateParams = $stateParams;
        this.busy = true;
        this.widgetsDistance = 20;
        this.minWidgetHeight = 370;

        // TODO switch to angular-busy
        $timeout(() => {
            this.busy = false;
        }, 1000);

        this.$scope.$watch(() => this.$element.find('.wrapper-dimmed').height(), () => {
            if (!this.gridsterOpts) return;
            this.panelAppEl = this.$element.find('.pnl-app');
            const panelAppElHeight = this.panelAppEl.height();
            this.widgetHeight = panelAppElHeight / 2 < this.minWidgetHeight ? this.minWidgetHeight : panelAppElHeight / 2;
            this.gridsterOpts.rowHeight = this.widgetHeight;
        });

        this.$scope.$on('sub-changed', (newValue, oldValue) => {
            this.subChanged = true;
            this.ready = false;
            this.setDashboards();
        });
    }

    initGridsterOptions() {
        this.gridsterOpts = {
            columns: 3, // the width of the grid, in columns
            pushing: true, // whether to push other items out of the way on move or resize
            floating: false, // whether to automatically float items up so they stack (you can temporarily disable if you are adding unsorted items with ng-repeat)
            swapping: true, // whether or not to have items of the same size switch places instead of pushing down if they are the same size
            width: 'auto', // can be an integer or 'auto'. 'auto' scales gridster to be the full width of its containing element
            colWidth: 'auto', // can be an integer or 'auto'.  'auto' uses the pixel width of the element divided by 'columns'
            rowHeight: this.widgetHeight, // can be an integer or 'match'.  Match uses the colWidth, giving you square widgets.
            margins: [this.widgetsDistance, this.widgetsDistance], // the pixel distance between each widget
            outerMargin: false, // whether margins apply to outer edges of the grid
            sparse: false, // "true" can increase performance of dragging and resizing for big grid (e.g. 20x50)
            isMobile: false, // stacks the grid items if true
            mobileBreakPoint: 700, // if the screen is not wider that this, remove the grid layout and stack the items
            mobileModeEnabled: true, // whether or not to toggle mobile mode when screen width is less than mobileBreakPoint
            minColumns: 3, // the minimum columns the grid must have
            minRows: 2, // the minimum height of the grid, in rows
            // maxRows: 100,
            maxRows: 2,
            defaultSizeX: 1, // the default width of a gridster item, if not specifed
            defaultSizeY: 1, // the default height of a gridster item, if not specified
            minSizeX: 1, // minimum column width of an item
            maxSizeX: null, // maximum column width of an item
            minSizeY: 1, // minumum row height of an item
            maxSizeY: null, // maximum row height of an item
            resizable: {
                enabled: false,
                handles: ['n', 'e', 's', 'w', 'ne', 'se', 'sw', 'nw'],
                start: (event, $element, widget) => { }, // optional callback fired when resize is started,
                resize: (event, $element, widget) => { }, // optional callback fired when item is resized,
                stop: (event, $element, widget) => { } // optional callback fired when item is finished resizing
            },
            draggable: {
                enabled: true, // whether dragging items is supported
                handle: '.drag-icon', // optional selector for drag handle
                start: (event, $element, widget) => { }, // optional callback fired when drag is started,
                drag: (event, $element, widget) => { }, // optional callback fired when item is moved,
                stop: (event, $element, widget) => { this.onDraggingFinished() } // optional callback fired when item is finished dragging
            }
        };

        this.gridItemMap = {
            sizeX: 'item.size.width',
            sizeY: 'item.size.height',
            row: 'item.position.y',
            col: 'item.position.x',
            minSizeY: 'item.minSizeY',
            maxSizeY: 'item.maxSizeY'
        };
    }

    $onInit() {
        this.setDashboards();
    }

    async getDashboardsData() {
        await this.dashboardService.getDashboardData(this.$stateParams).then(res => {
            const dashData = res[0];
            this.policiesWidgetData = dashData.policiesInfo;
            this.virtualMachinesWidgetData = dashData.virtualMachinesInfo;
            this.backupsWidgetData = dashData.backupsInfo;
            this.targetsWidgetData = dashData.targetsInfo;
            this.tasksWidgetData = dashData.tasksInfo;
            this.eventsWidgetData = dashData.eventsInfo
            this.ready = true;
        })
    }

    setDashboards() {
        this.getDashboardsData()
        this.$timeout(() => {
            this.panelAppEl = this.$element.find('.pnl-app');
            const panelAppElHeight = this.panelAppEl.height();
            this.widgetHeight = panelAppElHeight / 2 < this.minWidgetHeight ? this.minWidgetHeight : panelAppElHeight / 2;
            this.initGridsterOptions();
            this.isBackUpAdmin = this.utilsService.isBackUpAdmin();
            let gridsterPositions = this.gridsterPositions.getGridsterPoitions();
            if (!gridsterPositions.length || this.subChanged) {
                this.dashboardWidgets = this.dashboardService.getWidgets();
                this.gridsterPositions.setGridsterPoitions(this.dashboardWidgets);
                this.subChanged = false;
            } else {
                this.dashboardWidgets = gridsterPositions;
            }

        }, 0);
    }

    onDraggingFinished() {
        this.getCtrlPosition();
    }

    getCtrlPosition() {
        let gridsterPositions = this.gridsterPositions.getGridsterPoitions(),
            xPositions = gridsterPositions.filter(item => item.position).map(i => i.position.x),
            xLastPosition = xPositions && xPositions.length ? Math.max(...xPositions) : -1,
            ctrlWidget = gridsterPositions.filter(item => item.id === 'bck-ctrl')[0];
        this.endPosition = false;
        if (xLastPosition >= 0 && ctrlWidget && ctrlWidget.position && ctrlWidget.position.x === xLastPosition)
            this.endPosition = true;
    }



}

DashboardController.$inject = ['$scope', '$element', '$timeout', 'dashboardService', 'utilsService', 'gridsterPositions', '$stateParams'];

const dashboardComponent = {
    controller: DashboardController,
    template: require('./dashboard.template.html'),
    bindings: {
        numOfShowVms: '<',
        startingPage: '<'
    },
    scope: {}
};

module.exports = dashboardComponent;



// WEBPACK FOOTER //
// ./src/azurebackup/views/dashboard/dashboard.component.js